import { render, staticRenderFns } from "./CatchupPanel.vue?vue&type=template&id=ef5de464&scoped=true"
import script from "./CatchupPanel.vue?vue&type=script&lang=js"
export * from "./CatchupPanel.vue?vue&type=script&lang=js"
import style0 from "./CatchupPanel.vue?vue&type=style&index=0&id=ef5de464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5de464",
  null
  
)

export default component.exports